import React from 'react'
import "./Home.css"
import Header from './Header/Header'
import SpotLight from './SpotlLight/SpotLight'

const Home = () => {
  return (
    <div className='home' >
      
        <Header/>
        <SpotLight/>
    </div>
  )
}

export default Home